/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';

/**
 * @description 204 response
 */
export const optionsEquityInvestmentPageVisited204Schema = z.any();

/**
 * @description 505 response
 */
export const optionsEquityInvestmentPageVisited505Schema = z.any();

export const optionsEquityInvestmentPageVisitedMutationResponseSchema = z.lazy(
  () => optionsEquityInvestmentPageVisited204Schema
);
